var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from "vue-facing-decorator";
import { AlarmTypesClient, LookupsClient, AlarmTypeModel, CreateAlarmTypeCommand, UpdateAlarmTypeCommand } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { Alert } from "@/common/utils/alert";
import AlarmDefinitionsVue from "@/app/vues/admin/alarm-definitions.vue";
import { HttpHelper } from "@/app/utils/http-helper";
import { TextHelper } from "@/app/utils/text-helper";
import RouteNames from "@/app/router/routes";
import "@/app/component-hooks";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
const alarmTypeClient = new AlarmTypesClient(window.apiUrl);
const lookupClient = new LookupsClient(window.apiUrl);
let AlarmTypeVue = class AlarmTypeVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.alarmTypeId = 0;
        this.loaded = false;
        this.working = false;
        this.attemptedSave = false;
        // components
        this.msg = new Alert();
        // models
        this.alarmType = new AlarmTypeModel();
        // arrays
        this.alarmScopes = [];
        this.measurementTypes = [];
        this.stringStates = [];
        this.limitLayouts = [];
    }
    created() {
        this.alarmTypeId = parseInt(this.$route.params.id) || 0;
        this.get();
        this.getLookups();
    }
    ;
    mounted() {
    }
    ;
    // get
    get() {
        if (this.isNewAlarmType) {
            let alarmType = new AlarmTypeModel();
            alarmType.init({});
            this.map(alarmType);
            this.loaded = true;
            return;
        }
        this.working = true;
        alarmTypeClient
            .get(this.alarmTypeId)
            .then(response => {
            if (!response) {
                this.$router.push({ name: RouteNames.Home });
                return;
            }
            this.loaded = true;
            this.map(response);
            this.setValues({
                name: this.alarmType.alarmTypeName,
                scope: this.alarmScope
            });
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    getLookups() {
        let promises = [
            lookupClient
                .getAlarmScopes()
                .then(response => {
                this.alarmScopes = response.map(alarmScope => {
                    return {
                        value: alarmScope.alarmScopeId,
                        text: alarmScope.alarmScopeName
                    };
                });
                if (this.alarmType.alarmScopeId) {
                    this.setFieldValue("scope", this.alarmScope);
                }
            }),
            lookupClient
                .getMeasurementTypes()
                .then(response => {
                this.measurementTypes = [{ value: null, text: `All measurements` }].concat(response.map(measuremenType => {
                    return {
                        value: measuremenType.measurementTypeId,
                        text: measuremenType.measurementTypeName
                    };
                }));
            }),
            lookupClient
                .getStringStates()
                .then(response => {
                this.stringStates = [{ value: null, text: `All statuses` }].concat(response.map(stringState => {
                    return {
                        value: stringState.statusId,
                        text: stringState.statusName
                    };
                }));
            }),
            lookupClient
                .getLimitLayouts()
                .then(response => {
                this.limitLayouts = [{ value: null, text: `No layout` }].concat(response.map(limitLayout => {
                    return {
                        value: limitLayout.layoutId,
                        text: limitLayout.layoutName
                    };
                }));
            }),
        ];
        Promise.all(promises);
    }
    ;
    map(alarmType) {
        this.alarmType = alarmType;
        this.alarmType.alarmScopeId = alarmType.alarmScopeId;
        this.alarmType.measurementTypeId = alarmType.measurementTypeId || null;
        this.alarmType.stringStatusId = alarmType.stringStatusId || null;
        this.alarmType.limitLayoutId = alarmType.limitLayoutId || null;
    }
    ;
    // set
    save() {
        if (this.working)
            return;
        const handleSubmitAction = this.handleSubmit(() => {
            let promise = () => {
                return this.isNewAlarmType
                    ? alarmTypeClient.add(new CreateAlarmTypeCommand({ requestModel: this.alarmType }))
                    : alarmTypeClient.update(this.alarmType.alarmTypeId, new UpdateAlarmTypeCommand({ requestModel: this.alarmType }));
            };
            promise()
                .then(response => {
                this.alarmTypeId = response;
                Notifier.onOk();
                this.get();
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        }, () => {
            Notifier.onError("Please check that you have correctly entered all details.");
        });
        handleSubmitAction();
    }
    ;
    archive() {
        if (this.working || this.isNewAlarmType)
            return;
        this.$confirmModal.show("Are you sure that you want to archive this alarm type?", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.working = true;
            alarmTypeClient
                .delete(this.alarmType.alarmTypeId)
                .then(() => {
                this.alarmType.whenDeleted = new Date();
                Notifier.onOk(`Alarm Type # ${this.alarmType.alarmTypeId} has been successfully archived.`);
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    ;
    restore() {
        if (this.working || this.isNewAlarmType)
            return;
        this.working = true;
        alarmTypeClient
            .restore(this.alarmType.alarmTypeId)
            .then(() => {
            this.alarmType.whenDeleted = undefined;
            Notifier.onOk(`Alarm Type # ${this.alarmType.alarmTypeId} has been successfully restored.`);
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    goBack() {
        this.$router.back();
    }
    ;
    validate() {
        this.msg.clear();
        let valid = this.isValid;
        if (!valid)
            this.msg.error("Please complete all required fields.");
        return valid;
    }
    ;
    // computed
    get pageTitle() {
        return this.isNewAlarmType ? "New AlarmType" : this.alarmTypeTitle;
    }
    ;
    get alarmTypeTitle() {
        if (!this.alarmType)
            return "";
        return TextHelper.getRecordTitle(this.alarmType.alarmTypeName || "", this.isAlarmTypeArchived);
    }
    ;
    get isNewAlarmType() {
        return !this.alarmTypeId;
    }
    ;
    get isAlarmTypeArchived() {
        return this.alarmType.whenDeleted != null;
    }
    ;
    get isAlarmTypeNameValid() {
        return this.attemptedSave && !this.alarmType.alarmTypeName;
    }
    ;
    get isAlarmScopeValid() {
        return this.attemptedSave && !this.alarmType.alarmScopeId;
    }
    ;
    get isValid() {
        return !this.isAlarmTypeNameValid && this.isAlarmScopeValid;
    }
    ;
    get alarmScope() {
        return this.alarmScopes.filter(item => {
            return item.value == this.alarmType.alarmScopeId;
        })[0] || null;
    }
    ;
    set alarmScope(item) {
        this.setFieldValue("scope", item);
        if (!this.alarmType)
            return;
        this.alarmType.alarmScopeId = item.value;
    }
    ;
    get measurementType() {
        return this.measurementTypes.filter(item => {
            return item.value == this.alarmType.measurementTypeId;
        })[0] || null;
    }
    ;
    set measurementType(item) {
        if (!item)
            return;
        if (!this.alarmType)
            return;
        this.alarmType.measurementTypeId = item.value;
    }
    ;
    get stringStatus() {
        return this.stringStates.filter(item => {
            return item.value == this.alarmType.stringStatusId;
        })[0] || null;
    }
    ;
    set stringStatus(item) {
        if (!item)
            return;
        if (!this.alarmType)
            return;
        this.alarmType.stringStatusId = item.value;
    }
    ;
    get limitLayout() {
        return this.limitLayouts.filter(item => {
            return item.value == this.alarmType.limitLayoutId;
        })[0] || null;
    }
    ;
    set limitLayout(item) {
        if (!item)
            return;
        if (!this.alarmType)
            return;
        this.alarmType.limitLayoutId = item.value;
    }
    ;
    get selectPlaceholder() {
        return TextHelper.emptyListItemName;
    }
    ;
};
AlarmTypeVue = __decorate([
    Component({
        name: "AlarmTypeVue",
        components: {
            AlarmDefinitionsVue
        },
        setup() {
            const { errors, handleSubmit, defineInputBinds, defineComponentBinds, setFieldValue, setValues } = useForm({
                validationSchema: yup.object({
                    name: yup.string().trim().required(),
                    scope: yup.object().listOptionRequired(),
                }),
            });
            const nameVal = defineInputBinds('name');
            const scopeVal = defineComponentBinds('scope');
            return {
                errors,
                handleSubmit,
                setFieldValue,
                setValues,
                nameVal,
                scopeVal,
            };
        }
    })
], AlarmTypeVue);
export default AlarmTypeVue;
